module.exports = __webpack_public_path__ + "media/images/pic/popup/icon-flags-27421a9f69f3cacc99453b01ebbb9458.png";